export const PER_PAGE_LIMIT = 3; 
export const PER_PAGE_LIMIT_GALLERY = 16;